import * as React from 'react'
import { Theme } from '../data/models/funnelOrder/theme'
import { SRPRS_DEV, SRPRS_ENV } from '../env'
import * as pages from '../pages'
import { funnelUrls } from './funnelUrls'
import { memberUrls } from './memberUrls'
import { paymentUrls } from './paymentUrls'
import { personalUrls } from './personalUrls'

interface URL {
  urls: { [key: string]: string }
  component: React.ComponentClass | React.FC
  auth?: boolean
  funnel?: boolean
  theme?: Theme
  stopReset?: boolean
}

export interface URLs {
  [key: string]: URL
}

export const urls: URLs = {
  home: { urls: { default: '' }, component: pages.Home },
  how: {
    urls: {
      default: '/how-it-works/:extra(surprise-trip-fly)?',
      nl:
        '/hoe-het-werkt/:extra(verrassingsreis-auto|verrassingsreis-vliegtuig)?',
      be:
        '/hoe-het-werkt/:extra(verrassingsreis-auto|verrassingsreis-vliegtuig)?',
      dk:
        '/hvordan-det-virker/:extra(overraskelse-rejsebil|overraskelse-rejse-fly)?',
    },
    component: pages.How,
  },
  about: {
    urls: {
      default: '/about-us',
      nl: '/over-ons',
      be: '/over-ons',
      dk: '/om-os',
    },
    component: pages.About,
  },
  service: {
    urls: { default: '/contact-support', dk: '/kontakt-support' },
    component: pages.Service,
  },
  trips: { urls: { default: '/srprs-trips' }, component: pages.Trips },
  gift: {
    urls: {
      default: '/giftcard',
      nl: '/cadeaubon',
      be: '/cadeaubon',
      dk: '/gavekort',
    },
    component: pages.Giftcard,
  },
  giftgift: { urls: { default: '/cadeaubon' }, component: pages.GiftcardGift },
  conditions: {
    urls: {
      default: '/terms-conditions',
      nl: '/algemene-voorwaarden',
      be: '/algemene-voorwaarden',
      dk: '/generelle-betingelser',
    },
    component: pages.Conditions,
  },
  privacy: {
    urls: {
      default: '/privacypolicy',
      nl: '/privacybeleid',
      be: '/privacybeleid',
      dk: '/privatlivspolitik',
    },
    component: pages.Privacy,
  },
  bonbon: {
    urls: {
      default: '/redeem-giftcard',
      nl: '/cadeaubon-verzilveren',
      be: '/cadeaubon-verzilveren',
      dk: '/indloes-gavekort',
    },
    component: pages.GiftcardCampaign,
  },
  carteblanche: {
    urls: { default: '/carteblanche' },
    component: pages.GiftcardCampaign,
  },
  giveortake: {
    urls: { nl: '/giveortake', be: '/giveortake' },
    component: pages.GiftcardCampaign,
  },
  bolbol: {
    urls: { default: '/bolbol' },
    component: pages.EndedGiftcardCampaign,
  },
  spontaneity: {
    urls: {
      nl: '/inschrijving/bevestigd/:code',
      be: '/inschrijving/bevestigd/:code',
    },
    component: pages.SpontaneityConfirmation,
  },
  ziengs: { urls: { nl: '/ziengs' }, component: pages.GiftcardCodeCampaign },
  vrienden: {
    urls: { nl: '/vrienden', be: '/vrienden' },
    component: pages.GiftcardCodeCampaign,
  },
  topup: {
    urls: {
      nl: '/activeren',
      be: '/activeren',
    },
    component: pages.EndedGiftcardCampaign,
  },

  ...personalUrls,
  ...memberUrls,

  survey: {
    urls: { default: '/survey/:code', dk: '/spoergeskema/:code' },
    component: pages.Survey,
  },

  ...funnelUrls,
  ...paymentUrls,

  srprsInTheWild: {
    urls: {
      default: '/srprs-in-the-wild',
    },
    component: pages.SrprsInTheWild,
  },

  discountCode: {
    urls: {
      default: '/discount/:code',
      nl: '/korting/:code',
      be: '/korting/:code',
      dk: '/rabat/:code',
    },
    component: pages.DiscountCode,
  },

  // Around The World lead campaign
  aroundTermsAndConditions: {
    urls: {
      nl: '/de-wereld-rond/actievoorwaarden',
      be: '/de-wereld-rond/actievoorwaarden',
    },
    component: pages.EndedGiftcardCampaign,
  },
  aroundPersonal: {
    urls: {
      nl: '/de-wereld-rond/deelnemer/:code',
      be: '/de-wereld-rond/deelnemer/:code',
    },
    component: pages.EndedGiftcardCampaign,
  },
  aroundLanding: {
    urls: {
      nl: '/de-wereld-rond/:friendCode?/:code?',
      be: '/de-wereld-rond/:friendCode?/:code?',
    },
    component: pages.EndedGiftcardCampaign,
  },

  // 12 surprise trips
  leadTermsAndConditions: {
    urls: {
      nl: '/win/actievoorwaarden',
      be: '/win/actievoorwaarden',
      uk: '/win/terms-and-conditions',
      ie: '/win/terms-and-conditions',
      dk: '/win/generelle-betingelser',
    },
    component: pages.AroundTheWorldConditions,
  },
  leadPersonal: {
    urls: {
      nl: '/win/deelnemer/:code',
      be: '/win/deelnemer/:code',
      uk: '/win/participant/:code',
      ie: '/win/participant/:code',
      dk: '/win/deltager/:code',
    },
    component: pages.AroundTheWorldPersonal,
  },
  leadLanding: {
    urls: {
      nl: '/win/:friendCode?/:code?',
      be: '/win/:friendCode?/:code?',
      uk: '/win/:friendCode?/:code?',
      ie: '/win/:friendCode?/:code?',
      dk: '/win/:friendCode?/:code?',
    },
    component: pages.AroundTheWorldLanding,
  },

  // willyWonka
  willyWonka: {
    urls: {
      nl: '/all-you-need-is-more',
      be: '/all-you-need-is-more',
    },
    component: pages.WillyWonka,
  },

  // landingpages
  landingPage: {
    urls: {
      nl: '/stedentrip/:code',
      be: '/stedentrip/:code',
    },
    component: pages.LandingPage,
  },
  driveLandingPage: {
    urls: {
      nl: '/roadtrip/:code',
      be: '/roadtrip/:code',
    },
    component: pages.LandingPage,
  },

  // Member Get Member
  mgmsharing: {
    urls: {
      nl: '/vriendenvoordeel/delen',
      be: '/vriendenvoordeel/delen',
      uk: '/mates-rates/share',
      ie: '/mates-rates/share',
      dk: '/vennerabat/del',
    },
    component: pages.MGMShare,
  },
  mgmreferral: {
    urls: {
      nl: '/vriendenvoordeel/verzilveren',
      be: '/vriendenvoordeel/verzilveren',
      uk: '/mates-rates/redeem',
      ie: '/mates-rates/redeem',
      dk: '/vennerabat/indloes',
    },
    component: pages.MGMReferral,
  },
  additionalInfo: {
    urls: {
      default: '/extra-information/:orderId/traveller-docs',
      uk: '/extra-information/:orderId/traveller-docs',
      ie: '/extra-information/:orderId/traveller-docs',
      nl: '/extra-informatie/:orderId/reiziger-docs',
      be: '/extra-informatie/:orderId/reiziger-docs',
      dk: '/ekstra-information/:orderId/rejsende-dokumenter',
    },
    component: pages.ExtraInformation,
  },
  hotelConfirmation: {
    urls: {
      default: '/hotel-booking-rejection',
      uk: '/hotel-booking-rejection',
      ie: '/hotel-booking-rejection',
      nl: '/hotel-booking-rejection ',
      be: '/hotel-booking-rejection',
      dk: '/hotel-booking-rejection',
    },
    component: pages.HotelConfirmation,
  },
  reload: { urls: { default: '/_reload' }, component: pages.Reload },
}

if (SRPRS_ENV === 'editable') {
  // development/admin only urls
  urls.admin = { urls: { default: '/__admin' }, component: pages.AdminLogin }
} else if (SRPRS_DEV) {
  // development only urls
  urls.admin = { urls: { default: '/__admin' }, component: pages.AdminPage }
}
